import classNames from "classnames";
import * as React from "react";
import Icon from "../../../../../components/atoms/Icon";
import styles from "./styles.scss";

interface Props {
  isLimited: boolean;
  onClick: () => void;
}

const ToggleButton: React.FC<Props> = ({ isLimited, onClick }) => {
  const name = isLimited ? "icon-toggle-on" : "icon-toggle-off";
  const label = isLimited ? "あり" : "なし";

  return (
    <button
      type="button"
      onClick={onClick}
      className={classNames(styles.toggle, {
        [styles.limited]: isLimited,
      })}
    >
      <Icon name={name} className={styles.svg} />
      {label}
    </button>
  );
};

export default ToggleButton;
